// extracted by mini-css-extract-plugin
export default {"separator":"index_separator__sX7Bc","bull":"index_bull__evrBd"};